export const REQUEST_BILLING_ACTIVITIES = "REQUEST_BILLING_ACTIVITIES";
export const REQUEST_BILLING_ACTIVITIES_SUCCEEDED = "REQUEST_BILLING_ACTIVITIES_SUCCEEDED";
export const REQUEST_BILLING_ACTIVITIES_FAILED = "REQUEST_BILLING_ACTIVITIES_FAILED";
export const SAVE_BILLING_SKU_INFO = "SAVE_BILLING_SKU_INFO";
export const SAVE_BILLING_SKU_INFO_SUCCEEDED = "SAVE_BILLING_SKU_INFO_SUCCEEDED";
export const SAVE_BILLING_SKU_INFO_FAILED = "SAVE_BILLING_SKU_INFO_FAILED";
export const SAVE_LOCATE_INFO = "SAVE_LOCATE_INFO";
export const SAVE_RELATED_WORK_INFO_SUCCESS = "SAVE_RELATED_WORK_INFO_SUCCESS";
export const CLEAR_COMMENTS = "CLEAR_COMMENTS";

export const requestBillingActivities = (contractNumber, completedDate) => {
    return {
        type: REQUEST_BILLING_ACTIVITIES,
        billingActivitiesRequest: {
            contractNumber,
        },
        completedDate,
    };
};

export const requestBillingActivitiesSucceeded = (activities) => {
    return {
        type: REQUEST_BILLING_ACTIVITIES_SUCCEEDED,
        activities,
    };
};

export const requestBillingActivitiesFailed = (message) => {
    return {
        type: REQUEST_BILLING_ACTIVITIES_FAILED,
        message,
    };
};

export const saveBillingSKUInfo = (billingSKUInfoRequest, workOrderNumber, completionDate, refresh, filesToBeUploaded = []) => {
    return {
        type: SAVE_BILLING_SKU_INFO,
        billingSKUInfoRequest,
        workOrderNumber,
        completionDate,
        refresh,
        filesToBeUploaded,
    };
};

export const saveBillingSKUInfoSucceeded = (billingSKUInfoResponse) => {
    return {
        type: SAVE_BILLING_SKU_INFO_SUCCEEDED,
        billingSKUInfoResponse,
    };
};

export const saveBillingSKUInfoFailed = (message) => {
    return {
        type: SAVE_BILLING_SKU_INFO_FAILED,
        message,
    };
};

export const saveLocateInfo = (relatedWorkRequest, workOrderNumber, refresh) => {
    return {
        type: SAVE_LOCATE_INFO,
        relatedWorkRequest,
        workOrderNumber,
        refresh,
    };
};

export const saveRelatedWorkInfoSucceeded = (message) => {
    return {
        type: SAVE_RELATED_WORK_INFO_SUCCESS,
        message,
    };
};

export const REQUEST_BILLING_COMMENTS = "REQUEST_BILLING_COMMENTS";
export const REQUEST_BILLING_COMMENTS_SUCCESS = "REQUEST_BILLING_COMMENTS_SUCCESS";
export const REQUEST_BILLING_COMMENTS_FAIL = "REQUEST_BILLING_COMMENTS_FAIL";

export const fetchBillingComments = (workOrderNumber) => {
    return {
        type: REQUEST_BILLING_COMMENTS,
        workOrderNumber,
    };
};

export const requestBillingCommentsSucceeded = (comments) => {
    return {
        type: REQUEST_BILLING_COMMENTS_SUCCESS,
        comments,
    };
};

export const requestBillingCommentsFailed = (error) => {
    return {
        type: REQUEST_BILLING_COMMENTS_FAIL,
        error,
    };
};

export const UPDATE_CONTRACTOR_COMMENT = "UPDATE_CONTRACTOR_COMMENT";

export const updateContractorComment = (obj, newComment) => {
    return {
        type: UPDATE_CONTRACTOR_COMMENT,
        obj,
        newComment,
    };
};

export const ADD_CONTRACTOR_COMMENT = "ADD_CONTRACTOR_COMMENT";

export const addContractorComment = (newComment) => {
    return {
        type: ADD_CONTRACTOR_COMMENT,
        newComment,
    };
};

export const clearComments = () => {
    return {
        type: CLEAR_COMMENTS,
    };
};
